import { api } from '../utils/api';

class DataGovernanceService {
  /**
   * Get all policies for the current tenant
   */
  async getPolicies() {
    try {
      const response = await api.get('/data-governance/policies');
      return response.data;
    } catch (error) {
      console.error('Error fetching policies:', error);
      throw error;
    }
  }

  /**
   * Get policy for a specific entity
   */
  async getPolicy(entityType) {
    try {
      const response = await api.get(`/data-governance/policies/${entityType}`);
      // Handle different response structures: { success, policy } or direct policy object
      return response?.policy || response?.data || response;
    } catch (error) {
      console.error('Error fetching policy:', error);
      throw error;
    }
  }

  /**
   * Create or update a policy
   */
  async savePolicy(policyData) {
    try {
      const response = await api.post('/data-governance/policies', policyData);
      return response.data;
    } catch (error) {
      console.error('Error saving policy:', error);
      throw error;
    }
  }

  /**
   * Update a policy
   */
  async updatePolicy(entityType, policyData) {
    try {
      const response = await api.put(`/data-governance/policies/${entityType}`, policyData);
      return response.data;
    } catch (error) {
      console.error('Error updating policy:', error);
      throw error;
    }
  }

  /**
   * Delete a policy (revert to default)
   */
  async deletePolicy(entityType) {
    try {
      const response = await api.delete(`/data-governance/policies/${entityType}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting policy:', error);
      throw error;
    }
  }

  /**
   * Get list of available entities
   */
  async getEntities() {
    try {
      const response = await api.get('/data-governance/entities');
      return response.data;
    } catch (error) {
      console.error('Error fetching entities:', error);
      throw error;
    }
  }
}

export default new DataGovernanceService();

